import { defineMessages } from 'react-intl'

export const HIGHLIGHT_MODEL_CLASS_NAME = 'Highlight'

export const HIGHLIGHT_MODEL_KEY = {
  ID: 'id',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  CLASS_NAME: 'className',

  TYPE: 'type',
  DATA: 'data',

  // Foreign Keys
  PROFILE_ID: 'profileId'
}

// TODO
export const HIGHLIGHT_MODEL_TYPE = {
  WORKOUTS_COMPLETED_IN_A_ROW: 1,
  TRAINING_TIME_THIS_WEEK_IN_HOURS: 2,
  CALORIES_BURNED_THIS_WEEK: 3,
  CALORIES_BURNED_MORE_THAN_AVERAGE: 4,
  NEW_EXERCISE_WEIGHT_PERSONAL_RECORD: 5,
  TRIED_NEW_EXERCISES: 6
}

export const highlightMessage = defineMessages({
  workoutsCompletedInARow: {
    id: 'highlight.workoutsCompletedInARow',
    defaultMessage: 'You moved {count} days in a row.'
  },
  trainingTimeThisWeek: {
    id: 'highlight.trainingTimeThisWeek',
    defaultMessage: 'You’ve trained for more than {count} {count, plural, one {hour} other {hours}} this week.'
  },
  trainingTimeThisWeekMinutes: {
    id: 'highlight.trainingTimeThisWeekMinutes',
    defaultMessage: 'You’ve trained for more than {count} {count, plural, one {minute} other {minutes}} this week.'
  },
  caloriesBurnedThisWeek: {
    id: 'highlight.caloriesBurnedThisWeek',
    defaultMessage: 'You’ve burned more than {count} kcals this week.'
  },
  caloriesBurnedMoreThanAverage: {
    id: 'highlight.caloriesBurnedMoreThanAverage',
    defaultMessage: 'You’ve burned more {count} kcals, which is more than your average.'
  },
  newExerciseWeightPersonalRecord: {
    id: 'highlight.newExerciseWeightPersonalRecord',
    defaultMessage: 'You’ve never lifted {weight} on {exerciseName} before.'
  },
  triedNewExercises: {
    id: 'highlight.triedNewExercises',
    defaultMessage: 'You’ve challenged yourself by trying {count} new {count, plural, one {exercise} other {exercises}} - it feels good to switch things up.'
  }
})

export const HIGHLIGHT_MODEL_TYPE_TO_MESSAGE = {
  [HIGHLIGHT_MODEL_TYPE.WORKOUTS_COMPLETED_IN_A_ROW]: highlightMessage.workoutsCompletedInARow,
  [HIGHLIGHT_MODEL_TYPE.TRAINING_TIME_THIS_WEEK_IN_HOURS]: highlightMessage.trainingTimeThisWeek,
  [HIGHLIGHT_MODEL_TYPE.CALORIES_BURNED_THIS_WEEK]: highlightMessage.caloriesBurnedThisWeek,
  [HIGHLIGHT_MODEL_TYPE.CALORIES_BURNED_MORE_THAN_AVERAGE]: highlightMessage.caloriesBurnedMoreThanAverage,
  [HIGHLIGHT_MODEL_TYPE.NEW_EXERCISE_WEIGHT_PERSONAL_RECORD]: highlightMessage.newExerciseWeightPersonalRecord,
  [HIGHLIGHT_MODEL_TYPE.TRIED_NEW_EXERCISES]: highlightMessage.triedNewExercises
}

export const HIGHLIGHT_MODEL_AUDIT_CLASS_NAME = 'HighlightAudit'

export const HIGHLIGHT_MODEL_ORDER = [
  [
    'id',
    'DESC'
  ]
]

export const HIGHLIGHT_MODEL_PRIVATE_KEYS = []

export const HIGHLIGHT_MODEL_FOREIGN_KEYS = [
  HIGHLIGHT_MODEL_KEY.PROFILE_ID
]

export const HIGHLIGHT_MODEL_AUDIT = {
  CREATED: 'Highlight Created',
  UPDATED: 'Highlight Updated'
}

export const HIGHLIGHT_MODEL_SCOPE = {
  defaultScope: {
    attributes: {
      exclude: HIGHLIGHT_MODEL_PRIVATE_KEYS
    }
  }
}
